(() => {
  if (window.LichcardsContactEvents) return;
  window.LichcardsContactEvents = true;
  document.addEventListener('click', (event) => {
    if (!event.isTrusted) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    let method;
    if (/^tel:\+?31857444550$/i.test(href.replace(/[\s()-]/g, ''))) method = 'phone';
    else if (/^mailto:info@lichcards\.nl(?:\?|$)/i.test(href)) method = 'email';
    else if (/^https:\/\/(?:maps\.google\.com|www\.google\.com\/maps)(?:[/?]|$)/i.test(href)) method = 'directions';
    if (!method) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;
    const placement = link.closest('[data-lc-contact-placement]')?.dataset.lcContactPlacement
      || (link.closest('footer, .lc-footer') ? 'footer' : link.closest('.lc-contact') ? 'contact_page' : 'other');
    try {
      Promise.resolve(publish.call(window.Shopify.analytics, 'lichcards_contact_clicked', {
        method,
        placement,
        page_type: document.body.className.match(/(?:^|\s)template-([^\s]+)/)?.[1] || 'other'
      })).catch(() => {});
    } catch {}
  }, { passive: true });
})();
